import { render, staticRenderFns } from "./Kalendar.vue?vue&type=template&id=58003d8f&"
import script from "./Kalendar.vue?vue&type=script&lang=js&"
export * from "./Kalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports